import { gql } from "@apollo/client";
import { addTypePolicies } from "src/lib/graphql/cache";
import useGQLPaginatedQuery from "src/lib/graphql/hooks/useGQLPaginatedQuery";
import paginatedListFieldPolicy from "src/lib/graphql/utils/paginatedListFieldPolicy";
export const SUBJECT_NOTES_LIST_QUERY = gql `
  query EP_SubjectNotesList($subjectID: ID!, $filters: EPSubjectNoteListFilters, $pagination: PaginationOptions!) {
    ep_notesForSubject(subjectID: $subjectID, filters: $filters, pagination: $pagination) {
      totalCount
      list {
        id
        data {
          title
          topics
          slug
        }
        utime
      }
    }
  }
`;
;
export function useSubjectNotesListQuery(options) {
    return useGQLPaginatedQuery(SUBJECT_NOTES_LIST_QUERY, 'ep_notesForSubject', options);
}
addTypePolicies({
    Query: {
        fields: {
            ep_notesForSubject: paginatedListFieldPolicy(['subjectID', 'filters']),
        },
    },
});
